import { action, makeObservable, observable, onBecomeObserved } from "mobx"

import { catchErrors, subMerchantApi, whiteListIpsApi } from "@src/shared/api"
import { Pagination, SubmerchantResponse } from "@src/shared/api/generated"
import { CollectionWithPagination } from "@src/shared/classes/Collection/CollectionWithPagination"
import { loading } from "@src/shared/classes/utils/loading"

export type WhiteListIp = {
  address: string
  created_at: string
  id: string
  updated_at: string
}

export type WhiteListIpCreate = {
  address: string
  description?: string
}

export class WhiteLIstIpsCollection extends loading(
  ["fetch", "create", "delete", "update"],
  CollectionWithPagination<WhiteListIp>,
) {
  toEdit: string[] = []

  constructor() {
    super()

    makeObservable(this, {
      fetch: action.bound,
      toEdit: observable,
    })

    onBecomeObserved(this, "isLoading", this.load)
  }
  async create(req: WhiteListIpCreate) {
    try {
      const { data } = await whiteListIpsApi.createWhitelistIpAddress(req)

      if (data) {
        await this.load()
      }

      return true
    } catch (e) {
      catchErrors(e as any)
    }

    return false
  }
  async delete(id: string) {
    try {
      const { data } = await whiteListIpsApi.deleteWhitelistIpAddress(id)

      if (data) {
        await this.load()
      }

      return true
    } catch (e) {
      catchErrors(e as any)
    }

    return false
  }
  async fetch(): Promise<{
    data: WhiteListIp[]
    pagination: Pagination
  } | null> {
    try {
      const { data: { data } = {} } =
        await whiteListIpsApi.listWhitelistIpAddresses()

      if (data && (data as any).data) {
        return data as {
          data: WhiteListIp[]
          pagination: Pagination
        }
      }
    } catch (e: any) {
      catchErrors(e)
    }

    return null
  }

  async update() {}
}
